import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CartItems from "../components/CartItems"


function Cart() {
  return (
    <>
      <Header />
      <CartItems />
      <Footer />
    </>
  )
}

export default Cart